import React from 'react';
import './UpcomingEvents.css';

const UpcomingPharmaEvents = ({ Image, Title, Type, Description, Id, EventDate, EventTime, Location, Organizer, RegistrationClosingDate, routeOnPage }) => {
    return (
        <>
            <div className="col-lg-4 col-md-4 col-sm-12 mr-1 mb-3 topSkills topSkills__contentDisplay" key={Id}
                onClick={routeOnPage}>
                <div className="card-events">
                    <div className="card-events-body d-flex flex-column topSkills__content">
                        {(Image && Image != "") && <div className="justify-content-center align-items-center">
                            <img src={Image} alt="Store Name" className="img-fluid productTemplate__companyLogo" />
                        </div>}
                        <div className="card-events-details">
                            <h5 className="card-events-title">{Title}</h5>
                            <p className="card-events-title">{Type}</p>
                            <p className="card-events-title"><b>{EventDate?.toDate()?.toDateString()}</b> at  <b>{EventTime}</b></p>
                            {/* <p className="card-events-title">Registration Close at <b>{RegistrationClosingDate?.toDate()?.toDateString()}</b></p> */}
                            {/* <p className="card-events-title"><b>100 Winners</b></p> */}
                            <p className="card-events-title">{Location ? Location : ""} <b>{`By ${Organizer}`}</b></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UpcomingPharmaEvents
